import * as React from 'react';
import { FC } from 'react';

import { LockIconContainer, StyledRewardLock } from './reward-lock-icon.styled';

const RewardLockIcon: FC = props => (
  <LockIconContainer {...props}>
    <StyledRewardLock />
  </LockIconContainer>
);

export default RewardLockIcon;
